import { NavListItem } from "./charityData";


export const statesWithKeys = [
    { href: '/state/Alabama', name: 'Alabama', key: 'AL' },
    { href: '/state/Alaska', name: 'Alaska', key: 'AK' },
    { href: '/state/American Samoa', name: 'American Samoa', key: 'AS' },
    { href: '/state/Arizona', name: 'Arizona', key: 'AZ' },
    { href: '/state/Arkansas', name: 'Arkansas', key: 'AR' },
    { href: '/state/California', name: 'California', key: 'CA' },
    { href: '/state/Colorado', name: 'Colorado', key: 'CO' },
    { href: '/state/Connecticut', name: 'Connecticut', key: 'CT' },
    { href: '/state/Delaware', name: 'Delaware', key: 'DE' },
    { href: '/state/District of Columbia', name: 'District of Columbia', key: 'DC' },
    { href: '/state/Florida', name: 'Florida', key: 'FL' },
    { href: '/state/Georgia', name: 'Georgia', key: 'GA' },
    { href: '/state/Guam', name: 'Guam', key: 'GU' },
    { href: '/state/Hawaii', name: 'Hawaii', key: 'HI' },
    { href: '/state/Idaho', name: 'Idaho', key: 'ID' },
    { href: '/state/Illinois', name: 'Illinois', key: 'IL' },
    { href: '/state/Indiana', name: 'Indiana', key: 'IN' },
    { href: '/state/Iowa', name: 'Iowa', key: 'IA' },
    { href: '/state/Kansas', name: 'Kansas', key: 'KS' },
    { href: '/state/Kentucky', name: 'Kentucky', key: 'KY' },
    { href: '/state/Louisiana', name: 'Louisiana', key: 'LA' },
    { href: '/state/Maine', name: 'Maine', key: 'ME' },
    { href: '/state/Maryland', name: 'Maryland', key: 'MD' },
    { href: '/state/Massachusetts', name: 'Massachusetts', key: 'MA' },
    { href: '/state/Michigan', name: 'Michigan', key: 'MI' },
    { href: '/state/Minnesota', name: 'Minnesota', key: 'MN' },
    { href: '/state/Mississippi', name: 'Mississippi', key: 'MS' },
    { href: '/state/Missouri', name: 'Missouri', key: 'MO' },
    { href: '/state/Montana', name: 'Montana', key: 'MT' },
    { href: '/state/Nebraska', name: 'Nebraska', key: 'NE' },
    { href: '/state/Nevada', name: 'Nevada', key: 'NV' },
    { href: '/state/New Hampshire', name: 'New Hampshire', key: 'NH' },
    { href: '/state/New Jersey', name: 'New Jersey', key: 'NJ' },
    { href: '/state/New Mexico', name: 'New Mexico', key: 'NM' },
    { href: '/state/New York', name: 'New York', key: 'NY' },
    { href: '/state/North Carolina', name: 'North Carolina', key: 'NC' },
    { href: '/state/North Dakota', name: 'North Dakota', key: 'ND' },
    { href: '/state/Northern Mariana Islands', name: 'Northern Mariana Islands', key: 'MP' },
    { href: '/state/Ohio', name: 'Ohio', key: 'OH' },
    { href: '/state/Oklahoma', name: 'Oklahoma', key: 'OK' },
    { href: '/state/Oregon', name: 'Oregon', key: 'OR' },
    { href: '/state/Pennsylvania', name: 'Pennsylvania', key: 'PA' },
    { href: '/state/Puerto Rico', name: 'Puerto Rico', key: 'PR' },
    { href: '/state/Rhode Island', name: 'Rhode Island', key: 'RI' },
    { href: '/state/South Carolina', name: 'South Carolina', key: 'SC' },
    { href: '/state/South Dakota', name: 'South Dakota', key: 'SD' },
    { href: '/state/Tennessee', name: 'Tennessee', key: 'TN' },
    { href: '/state/Texas', name: 'Texas', key: 'TX' },
    { href: '/state/Utah', name: 'Utah', key: 'UT' },
    { href: '/state/Vermont', name: 'Vermont', key: 'VT' },
    { href: '/state/Virgin Islands', name: 'Virgin Islands', key: 'VI' },
    { href: '/state/Virginia', name: 'Virginia', key: 'VA' },
    { href: '/state/Washington', name: 'Washington', key: 'WA' },
    { href: '/state/West Virginia', name: 'West Virginia', key: 'WV' },
    { href: '/state/Wisconsin', name: 'Wisconsin', key: 'WI' },
    { href: '/state/Wyoming', name: 'Wyoming', key: 'WY' }
];


export const states:Array<NavListItem> = [
    { href: '/state/Alabama', name: 'Alabama' },
    { href: '/state/Alaska', name: 'Alaska' },
    { href: '/state/American Samoa', name: 'American Samoa' },
    { href: '/state/Arizona', name: 'Arizona' },
    { href: '/state/Arkansas', name: 'Arkansas' },
    { href: '/state/California', name: 'California' },
    { href: '/state/Colorado', name: 'Colorado' },
    { href: '/state/Connecticut', name: 'Connecticut' },
    { href: '/state/Delaware', name: 'Delaware' },
    { href: '/state/District of Columbia', name: 'District of Columbia' },
    { href: '/state/Florida', name: 'Florida' },
    { href: '/state/Georgia', name: 'Georgia' },
    { href: '/state/Guam', name: 'Guam' },
    { href: '/state/Hawaii', name: 'Hawaii' },
    { href: '/state/Idaho', name: 'Idaho' },
    { href: '/state/Illinois', name: 'Illinois' },
    { href: '/state/Indiana', name: 'Indiana' },
    { href: '/state/Iowa', name: 'Iowa' },
    { href: '/state/Kansas', name: 'Kansas' },
    { href: '/state/Kentucky', name: 'Kentucky' },
    { href: '/state/Louisiana', name: 'Louisiana' },
    { href: '/state/Maine', name: 'Maine' },
    { href: '/state/Maryland', name: 'Maryland' },
    { href: '/state/Massachusetts', name: 'Massachusetts' },
    { href: '/state/Michigan', name: 'Michigan' },
    { href: '/state/Minnesota', name: 'Minnesota' },
    { href: '/state/Mississippi', name: 'Mississippi' },
    { href: '/state/Missouri', name: 'Missouri' },
    { href: '/state/Montana', name: 'Montana' },
    { href: '/state/Nebraska', name: 'Nebraska' },
    { href: '/state/Nevada', name: 'Nevada' },
    { href: '/state/New Hampshire', name: 'New Hampshire' },
    { href: '/state/New Jersey', name: 'New Jersey' },
    { href: '/state/New Mexico', name: 'New Mexico' },
    { href: '/state/New York', name: 'New York' },
    { href: '/state/North Carolina', name: 'North Carolina' },
    { href: '/state/North Dakota', name: 'North Dakota' },
    { href: '/state/Northern Mariana Islands', name: 'Northern Mariana Islands' },
    { href: '/state/Ohio', name: 'Ohio' },
    { href: '/state/Oklahoma', name: 'Oklahoma' },
    { href: '/state/Oregon', name: 'Oregon' },
    { href: '/state/Pennsylvania', name: 'Pennsylvania' },
    { href: '/state/Puerto Rico', name: 'Puerto Rico' },
    { href: '/state/Rhode Island', name: 'Rhode Island' },
    { href: '/state/South Carolina', name: 'South Carolina' },
    { href: '/state/South Dakota', name: 'South Dakota' },
    { href: '/state/Tennessee', name: 'Tennessee' },
    { href: '/state/Texas', name: 'Texas' },
    { href: '/state/Utah', name: 'Utah' },
    { href: '/state/Vermont', name: 'Vermont' },
    { href: '/state/Virgin Islands', name: 'Virgin Islands' },
    { href: '/state/Virginia', name: 'Virginia' },
    { href: '/state/Washington', name: 'Washington' },
    { href: '/state/West Virginia', name: 'West Virginia' },
    { href: '/state/Wisconsin', name: 'Wisconsin' },
    { href: '/state/Wyoming', name: 'Wyoming' }
  ];

export const statesAbbriviation:Array<NavListItem> = [
    {href: '/state/Alaska', name: 'AK' },
    {href: '/state/Alabama', name: 'AL' },
    {href: '/state/Arkansas', name: 'AR' },
    {href: '/state/American Samoa', name: 'AS' },
    {href: '/state/Arizona', name: 'AZ' },
    {href: '/state/California', name: 'CA' },
    {href: '/state/Colorado', name: 'CO' },
    {href: '/state/Connecticut', name: 'CT' },
    {href: '/state/District of Columbia', name: 'DC' },
    {href: '/state/Delaware', name: 'DE' },
    {href: '/state/Florida', name: 'FL' },
    {href: '/state/Georgia', name: 'GA' },
    {href: '/state/Guam', name: 'GU' },
    {href: '/state/Hawaii', name: 'HI' },
    {href: '/state/Iowa', name: 'IA' },
    {href: '/state/Idaho', name: 'ID' },
    {href: '/state/Illinois', name: 'IL' },
    {href: '/state/Indiana', name: 'IN' },
    {href: '/state/Kansas', name: 'KS' },
    {href: '/state/Kentucky', name: 'KY' },
    {href: '/state/Louisiana', name: 'LA' },
    {href: '/state/Massachusetts', name: 'MA' },
    {href: '/state/Maryland', name: 'MD' },
    {href: '/state/Maine', name: 'ME' },
    {href: '/state/Michigan', name: 'MI' },
    {href: '/state/Minnesota', name: 'MN' },
    {href: '/state/Missouri', name: 'MO' },
    {href: '/state/N. Mariana Islands', name: 'MP' },
    {href: '/state/Mississippi', name: 'MS' },
    {href: '/state/Montana', name: 'MT' },
    {href: '/state/North Carolina', name: 'NC' },
    {href: '/state/North Dakota', name: 'ND' },
    {href: '/state/Nebraska', name: 'NE' },
    {href: '/state/New Hampshire', name: 'NH' },
    {href: '/state/New Jersey', name: 'NJ' },
    {href: '/state/New Mexico', name: 'NM' },
    {href: '/state/Nevada', name: 'NV' },
    {href: '/state/New York', name: 'NY' },
    {href: '/state/Ohio', name: 'OH' },
    {href: '/state/Oklahoma', name: 'OK' },
    {href: '/state/Oregon', name: 'OR' },
    {href: '/state/Pennsylvania', name: 'PA' },
    {href: '/state/Puerto Rico', name: 'PR' },
    {href: '/state/Rhode Island', name: 'RI' },
    {href: '/state/South Carolina', name: 'SC' },
    {href: '/state/South Dakota', name: 'SD' },
    {href: '/state/Tennessee', name: 'TN' },
    {href: '/state/Texas', name: 'TX' },
    {href: '/state/Utah', name: 'UT' },
    {href: '/state/Virginia', name: 'VA' },
    {href: '/state/Virgin Islands', name: 'VI' },
    {href: '/state/Vermont', name: 'VT' },
    {href: '/state/Washington', name: 'WA' },
    {href: '/state/Wisconsin', name: 'WI' },
    {href: '/state/West Virginia', name: 'WV' },
    {href: '/state/Wyoming', name: 'WY' }
  ];


  